import React, {ReactElement} from "react";
import {Loader} from "../../components/Loader";
import {Table} from "../../components/Table/Table";
import {Dictionary} from "../../components/Dictionary";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {FormComponent} from "../../components/FormComponent";
import {RightAside} from "../../components/Aside/RightAside";
import {SignTurnRightFill} from "react-bootstrap-icons";
import {SysButton} from "../../components/Elements/SysButton";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {StatusPage} from "../StatusPage";
import {Util} from "../../components/Util";
import {DateTime} from "../../components/ListComponent/DateTime";
import {DetailsWithList} from "../../components/DetailsWithList";
import {ListLoader} from "../../components/ListLoader";
import {TBody} from "../../components/Table/TBody";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import Info from "../../components/FormComponent/FormGroup/Info";

export class OrderDetails extends DetailsWithList {
    protected dictionary: Dictionary = new Dictionary();

    componentDidMount() {
        if (this.user.hasRight('order/details') === false && this.user.hasRight('order/edit') === false) {
            return;
        }
        this.fetchUrl = '/order/' + window.location.pathname.split('/').pop();
        this.fetchItem();
    }

    render() {
        if (this.user.hasRight('order/details') === false && this.user.hasRight('order/edit') === false) {
            return <StatusPage code={403} message="forbidden"/>;
        }
        if (this.state?.code && this.state?.message) {
            return <StatusPage code={this.state.code} message={this.state.message}/>;
        }
        if (typeof this.state?.item === 'undefined') {
            return <Loader/>;
        }

        let items: any = [], quantity: number = 0, quantity_shipped: number = 0, quantity_diff: number = 0,
            reserved_quantity: number = 0;

        for (let i in this.state?.items) {
            let elem = this.state?.items[i];
            let item = [
                elem.id + " ",
                elem.reference_id,
                elem.suborder_id,
                elem.product_id ? Util.link(elem.sku, '/product/details/' + elem.product_id) : elem.sku,
                elem.name,
                Dictionary.PriceFormat(elem.unit_price_gross, elem.currency),
                Dictionary.PriceFormat(elem.unit_price_net, elem.currency),
                elem.vat_rate,
                elem.quantity,
                elem.quantity_shipped || '-',
                elem.quantity_diff || '-',
                elem.reserved_quantity || '-',
                (elem.quantity - (elem.reserved_quantity || 0))
            ];

            if (this.state?.item.type === 'B2B') {
                if (elem.product_pack_quantity && elem.quantity % elem.product_pack_quantity) {
                    item.push(<>
                        <span style={{
                            display: 'block',
                            float: 'left',
                            marginBottom: 0,
                            padding: '2px 8px 2px 0'
                        }}>{elem.product_pack_quantity}</span>
                        <span className={'alert alert-danger'}
                              style={{
                                  width: 'auto',
                                  marginBottom: 0,
                                  padding: '2px 8px'
                              }}>{elem.quantity}%{elem.product_pack_quantity}={elem.quantity % elem.product_pack_quantity}</span>
                    </>)
                } else {
                    item.push(elem.product_pack_quantity || '-')
                }
            }

            items.push(item);
            quantity = quantity + elem.quantity;
            quantity_shipped = quantity_shipped + elem.quantity_shipped;
            quantity_diff = quantity_diff + elem.quantity_diff;
            reserved_quantity = reserved_quantity + elem.reserved_quantity;
        }

        const saveUrl = "/order/" + this.state.item.id;
        const synchronizationAction = (e: any) => {
            this.synchronizationAction(e);
        };
        const closeOrderAction = (e: any) => {
            this.closeOrderAction(e);
        };

        return (
            <div className="x-form">

                <input type="hidden" name="id" defaultValue={this.state?.item.id || ''}/>

                <div className="row gx-4">
                    {this.state?.item.nfo &&
                        <div className="col-md-12 details">
                            <div className={Util.alertTypeByStatus(this.state.item.status)} role="alert">
                                {this.state?.item.nfo}
                            </div>
                        </div>
                    }

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>
                            {this.dictionary.get['order-details']}
                            {this.isEditable(true) && <SysButton onClick={this.editDetails} type={'PencilFill'}
                                                                 text={this.dictionary.get['edit']}/>}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                {this.getDetails(false)}
                            </table>
                        </div>
                        {this.isEditable(true) && <div className="hidden">
                            <form onSubmit={this.handleSubmit} action={saveUrl} method="PATCH" id="edit-details"
                                  className="hidden details">

                                <h6>
                                    {this.dictionary.get['edit-order-details']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                </h6>

                                <div className="table-responsive">
                                    <table className="table table-sm align-middle inlineTable">
                                        {this.getDetails(true)}
                                    </table>
                                </div>

                                <FormSubmit aside={true}/>
                            </form>
                        </div>}
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>
                            {this.dictionary.get['shipping-info']}
                            {this.isEditable() && <SysButton onClick={this.editShippingInfo} type={'PencilFill'}
                                                             text={this.dictionary.get['edit']}/>}
                        </h6>
                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                {this.getShippingInfo(false)}
                            </table>
                        </div>
                        {this.isEditable() && <div className="hidden">
                            <form onSubmit={this.handleSubmit} action={saveUrl} method="PATCH" id="edit-shipping-info"
                                  className="hidden details">

                                <h6>
                                    {this.dictionary.get['edit-shipping-info']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                </h6>

                                <div className="table-responsive">
                                    <table className="table table-sm align-middle inlineTable">
                                        {this.getShippingInfo(true)}
                                    </table>
                                </div>
                                {this.state?.item.status === 'address-error' && <div className="form-group">
                                    <div className="alert alert-info" role="alert">
                                        {this.dictionary.get['address-error-open-info']}
                                    </div>
                                </div>}
                                {this.state?.item.status === 'address-error' &&
                                    <FormSubmit aside={true} label={this.dictionary.get['save-and-open']}/>}
                                {this.state?.item.status !== 'address-error' && <FormSubmit aside={true}/>}
                            </form>
                        </div>}
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>
                            {this.dictionary.get['shipping-address']}
                            {this.isEditable() && <SysButton onClick={this.editShippingAddress} type={'PencilFill'}
                                                             text={this.dictionary.get['edit']}/>}
                        </h6>
                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                {this.getShippingAddress(false)}
                            </table>
                        </div>
                        {this.isEditable() && <div className="hidden">
                            <form onSubmit={this.handleSubmit} action={saveUrl} method="PATCH"
                                  id="edit-shipping-address"
                                  className="hidden details">

                                <h6>
                                    {this.dictionary.get['edit-shipping-address']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                </h6>

                                <div className="table-responsive">
                                    <table className="table table-sm align-middle inlineTable wideRight">
                                        {this.getShippingAddress(true)}
                                    </table>
                                </div>

                                <FormSubmit aside={true}/>
                            </form>
                        </div>}
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>{this.dictionary.get['billing-address']}</h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                <Table.TBody {...{
                                    data: [
                                        [this.dictionary.get['name'], this.state?.item.billing_name || ''],
                                        [this.dictionary.get['contact_name'], this.state?.item.billing_contact_name || ''],
                                        [this.dictionary.get['email'], this.state?.item.billing_email || ''],
                                        [this.dictionary.get['phone'], this.state?.item.billing_phone || ''],
                                        [this.dictionary.get['country'], this.state?.item.billing_country || ''],
                                        [this.dictionary.get['state'], this.state?.item.billing_state || ''],
                                        [this.dictionary.get['city'], this.state?.item.billing_city || ''],
                                        [this.dictionary.get['postcode'], this.state?.item.billing_postcode || ''],
                                        [this.dictionary.get['address1'], this.state?.item.billing_address1 || ''],
                                        [this.dictionary.get['address2'], this.state?.item.billing_address2 || '']
                                    ]
                                }}/>
                            </table>
                        </div>
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>{this.dictionary.get['sell_to-address']}</h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                <Table.TBody {...{
                                    data: [
                                        [this.dictionary.get['name'], this.state?.item.sell_to_name || ''],
                                        [this.dictionary.get['contact_name'], this.state?.item.sell_to_contact_name || ''],
                                        [this.dictionary.get['email'], this.state?.item.sell_to_email || ''],
                                        [this.dictionary.get['phone'], this.state?.item.sell_to_phone || ''],
                                        [this.dictionary.get['country'], this.state?.item.sell_to_country || ''],
                                        [this.dictionary.get['state'], this.state?.item.sell_to_state || ''],
                                        [this.dictionary.get['city'], this.state?.item.sell_to_city || ''],
                                        [this.dictionary.get['postcode'], this.state?.item.sell_to_postcode || ''],
                                        [this.dictionary.get['address1'], this.state?.item.sell_to_address1 || ''],
                                        [this.dictionary.get['address2'], this.state?.item.sell_to_address2 || '']
                                    ]
                                }}/>
                            </table>
                        </div>
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>{this.dictionary.get['fulfillment-info']}
                            {this.hasOperations() &&
                                <SysButton onClick={this.openOperations} type={'AirplaneFill'}
                                           className="lowercase"
                                           text={this.dictionary.get['operations']}/>}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                <Table.TBody {...{
                                    data: [
                                        [this.dictionary.get['created_at'] + ' (BC)', DateTime.create({
                                            value: this.state?.item.created_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['imported_at'] + ' (BC:HUB)', DateTime.create({
                                            value: this.state?.item.imported_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['fulfillment_imported_at'] + ' (HUB:EE)', DateTime.create({
                                            value: this.state?.item.fulfillment_imported_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['picking_start_at'] + ' (EE)', DateTime.create({
                                            value: this.state?.item.picking_start_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['picking_end_at'] + ' (EE)', DateTime.create({
                                            value: this.state?.item.picking_end_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['packing_end_at'] + ' (EE)', DateTime.create({
                                            value: this.state?.item.packing_end_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['manifest_date'] + ' (EE)', DateTime.create({
                                            value: this.state?.item.manifest_date || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['manifest_no'] + ' (EE)', Util.copyCell(this.state?.item.manifest_no || '')],
                                        [this.dictionary.get['sync_at'] + ' (EE:HUB)', DateTime.create({
                                            value: this.state?.item.sync_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['closed_at'] + ' (HUB:BC)', DateTime.create({
                                            value: this.state?.item.closed_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['cancelled_at'] + ' (EE)', DateTime.create({
                                            value: this.state?.item.cancelled_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['updated_by'] + ' (HUB)', this.state?.item.updated_by || ''],
                                        [this.dictionary.get['updated_at'] + ' (HUB)', DateTime.create({
                                            value: this.state?.item.updated_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['archived_at'] + ' (BC)', DateTime.create({
                                            value: this.state?.item.archived_at || '',
                                            inline: true
                                        })],
                                    ]
                                }}/>
                            </table>
                        </div>
                        {this.hasOperations() && <div className="hidden">
                            <div id="open-operations" className="hidden details">
                                <h6>
                                    {this.dictionary.get['operations']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                    <br/>&nbsp;
                                </h6>
                                <div className="table-responsive">
                                    <table className="table table-sm align-middle wideRight">
                                        <tbody>
                                        {(this.state?.item.status === 'in-transit' || this.state?.item.status === 'sync-error') &&
                                            <tr>
                                                <td>
                                                    <SysButton type={'SignTurnRightFill'}
                                                               text={this.state?.item.fulfillment_service_name + ' - ' + this.dictionary.get['synchronization']}
                                                               onClick={synchronizationAction}
                                                               data-target-url="/order/synchronization/{orderId}"/>
                                                    <Info style={{
                                                        margin: '20px 10px 5px',
                                                        width: '95%'
                                                    }}>{this.dictionary.get['synchronization-info']}</Info>
                                                </td>
                                            </tr>}
                                        {(this.state?.item.status === 'cancelled') && <tr>
                                            <td>
                                                <SysButton type={'SignTurnRightFill'}
                                                           text={'BravoHUB - ReOpen Order'}
                                                           onClick={synchronizationAction}
                                                           data-target-url="/order/{orderId}/reopen"/>
                                                <Info style={{
                                                    margin: '20px 10px 5px',
                                                    width: '95%'
                                                }}>{this.dictionary.get['reopen-order-process-info']}</Info>
                                            </td>
                                        </tr>}
                                        {(this.state?.item.status === 'insufficient-quantity' ||
                                            this.state?.item.status === 'address-error' ||
                                            this.state?.item.status === 'import-error' ||
                                            this.state?.item.status === 'draft') && <tr>
                                            <td>
                                                <SysButton type={'SignTurnRightFill'}
                                                           text={'BusinessCentral - ReImport Order'}
                                                           onClick={synchronizationAction}
                                                           data-target-url="/order/{orderId}/reimport"/>
                                                <Info style={{
                                                    margin: '20px 10px 5px',
                                                    width: '95%'
                                                }}>{this.dictionary.get['reimport-order-process-info']}</Info>
                                            </td>
                                        </tr>}
                                        {(this.state?.item.status === 'draft' ||
                                            this.state?.item.status === 'scheduled' ||
                                            this.state?.item.status === 'address-error' ||
                                            this.state?.item.status === 'create-error' ||
                                            this.state?.item.status === 'on-hold' ||
                                            this.state?.item.status === 'insufficient-quantity' ||
                                            this.state?.item.status === 'duplication-error' ||
                                            this.state?.item.status === 'import-error' ||
                                            this.state?.item.status === 'customer-error' ||
                                            this.state?.item.status === 'unknown-product') && <tr>
                                            <td>
                                                <SysButton type={'SignTurnRightFill'}
                                                           text={'BravoHUB - Open Order Process'}
                                                           onClick={synchronizationAction}
                                                           data-target-url="/order/{orderId}/open"/>
                                                <Info style={{
                                                    margin: '20px 10px 5px',
                                                    width: '95%'
                                                }}>{this.dictionary.get['open-order-process-info']}</Info>
                                            </td>
                                        </tr>}
                                        {this.state?.item.status === 'close-error' && <tr>
                                            <td colSpan={2}>
                                                <SysButton type={'SignTurnRightFill'}
                                                           text={this.state?.item.service_name + ' - ' + this.dictionary.get['close-order']}
                                                           onClick={closeOrderAction}
                                                           data-target-url="/order/closeOrder/{orderId}"/>
                                            </td>
                                        </tr>}
                                        </tbody>
                                    </table>
                                </div>
                                <FormSubmit aside={true} nosubmit={true}/>
                            </div>
                        </div>}
                    </div>

                    <div className="col-12">
                        <h6>
                            {this.dictionary.get['order-items']} - ({items.length} {this.dictionary.get['pc']})
                        </h6>
                        <div className="row" style={{marginBottom: '6px'}}>
                            <div className="col-12 col-sm-3" key={TBody.index++}>
                                {this.dictionary.get['quantity']}:&nbsp;<FormattedNumber
                                value={quantity}/>&nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-12 col-sm-3" key={TBody.index++}>
                                {this.dictionary.get['quantity_shipped']}:&nbsp;<FormattedNumber
                                value={quantity_shipped}/>&nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-12 col-sm-3" key={TBody.index++}>
                                {this.dictionary.get['quantity_diff']}:&nbsp;<FormattedNumber
                                value={quantity_diff}/>&nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-12 col-sm-3" key={TBody.index++}>
                                {this.dictionary.get['reserved_quantity']}:&nbsp;<FormattedNumber
                                value={reserved_quantity}/>&nbsp;{this.dictionary.get['pc']}
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover table-sm align-middle">
                                <thead>
                                <tr>
                                    <th className="sortable" data-sortkey="i.`id`">
                                        ID <i className="bi bi-sort-down-alt"></i>
                                    </th>
                                    <th className="sortable"
                                        data-sortkey="i.`reference_id`">{this.dictionary.get['reference_id']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`fulfillment_id`">{this.dictionary.get['fulfillment_id']}</th>
                                    <th className="sortable" data-sortkey="i.`sku`">{this.dictionary.get['sku']}</th>
                                    <th className="sortable" data-sortkey="i.`name`">{this.dictionary.get['name']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`unit_price_gross`">{this.dictionary.get['unit_price_gross']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`unit_price_net`">{this.dictionary.get['unit_price_net']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`vat_rate`">{this.dictionary.get['vat_rate']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`quantity`">{this.dictionary.get['quantity']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`quantity_shipped`">{this.dictionary.get['quantity_shipped']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`quantity_diff`">{this.dictionary.get['quantity_diff']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`reserved_quantity`">{this.dictionary.get['reserved_quantity']}</th>
                                    <th className="sortable"
                                        data-sortkey="(i.`quantity`-COALESCE(i.`reserved_quantity`, 0))">{this.dictionary.get['reserved_quantity_diff']}</th>
                                    {this.state?.item.type === 'B2B' &&
                                        <th className="sortable"
                                            data-sortkey="pp.`quantity`">{this.dictionary.get['carton-contains']}</th>}
                                </tr>
                                </thead>
                                <Table.TBody {...{data: items}}/>
                            </table>
                        </div>
                    </div>
                </div>
                {!items.length && <ListLoader/>}
            </div>
        );
    }

    synchronizationAction(event: any): void {
        event.preventDefault();
        this.sendOperation(event);
    }

    closeOrderAction(event: any): void {
        event.preventDefault();
        this.sendOperation(event);
    }

    sendOperation(event: any): void {
        if (RightAside.reload) {
            return;
        }
        RightAside.reload = true;
        const element = event.target.closest('div');

        const alertInfo = element.closest('.details').querySelector('.alert.alert-info') as HTMLElement;
        alertInfo.classList.remove('hide');

        const uriPath: string = element.getAttribute('data-target-url').replace('{orderId}', this.state?.item.id);

        this.request.fetch(uriPath, null, {
            method: 'POST'
        }).then((data: any) => {
            // RightAside.reload = false;
            alertInfo.classList.add('hide');

            FormComponent.checkMessages(data);

            const alert = element.closest('.details').querySelector('.alert.alert-success') as HTMLElement;

            alert.innerHTML = this.dictionary.get['success-operation'];
            alert.classList.remove('hide');
        }).catch(error => {
            const alert = element.closest('.details').querySelector('.alert.alert-danger') as HTMLElement;
            alert.innerHTML = this.dictionary.get[error.message || 'success-operation'];
            alert.classList.remove('hide');
            console.error(error);
        });
    }

    private hasOperations(): boolean {
        if (this.user.hasRight('order/edit') === false) {
            return false;
        }
        switch (this.state?.item.status) {
            case 'draft':
            case 'in-transit':
            case 'sync-error':
            case 'scheduled':
            case 'cancelled':
            case 'address-error':
            case 'import-error':
            case 'create-error':
            case 'on-hold':
            case 'unknown-product':
            case 'insufficient-quantity':
            case 'close-error':
            case 'duplication-error':
                return true;
            default:
                return false;
        }
    }

    private isEditable(onlyRights: boolean = false): boolean {
        if (this.user.hasRight('order/edit') === false) {
            return false;
        }
        if (onlyRights) {
            return true;
        }
        switch (this.state?.item.status) {
            case 'draft':
            case 'address-error':
            case 'import-error':
            case 'insufficient-quantity':
            case 'duplication-error':
                return true;
        }
        return false;
    }

    private getStatus(input: boolean, status: any): ReactElement {
        if (!input || ['closed', 'close-error', 'create-error', 'insufficient-quantity', 'import-error', 'duplication-error'].indexOf(status) === -1) {
            return Util.status(status, {tooltip: this.dictionary.get[status + '-info']});
        }
        let statusList: string[] = [status];
        switch (status) {
            case 'duplication-error':
                statusList = ['duplication-error', 'draft', 'archived'];
                break;
            case 'import-error':
                statusList = ['draft', 'import-error', 'cancelled', 'archived'];
                break;
            case 'insufficient-quantity':
                statusList = ['insufficient-quantity', 'closed', 'cancelled', 'archived'];
                break;
            case 'closed':
            case 'close-error':
                statusList = ['closed', 'close-error', 'cancelled', 'archived'];
                break;
            case 'create-error':
                statusList = ['draft', 'create-error', 'in-transit', 'b2b-in-transit'];
                break;
        }

        return (
            <FormGroup.Select {...{
                id: 'status',
                skipLabel: true,
                basic: 'please-select',
                items: statusList,
                defaultValue: status
            }}/>
        );
    }

    private getType(input: boolean, type: any): ReactElement {
        if (!input || !this.isEditable() || ['draft'].indexOf(this.state?.item.status) === -1) {
            return type;
        }
        return (
            <FormGroup.Select {...{
                id: 'type',
                skipLabel: true,
                basic: 'please-select',
                items: ['B2C', 'B2B'],
                defaultValue: type
            }}/>
        );
    }

    private getInput(input: boolean, id: string, value: any): ReactElement {
        if (!input || !this.isEditable()) {
            return value || '';
        }
        if (value && React.isValidElement(value)) {
            value = (value as ReactElement).props.children as string;
        }
        return (
            <FormGroup.Input {...{skipLabel: true, id: id, defaultValue: value}}/>
        );
    }

    private getPrice(input: boolean, amount_id: string, amount: any, currency_id: string, currency: any): ReactElement {
        if (!input || !this.isEditable()) {
            let value: any = Dictionary.PriceFormat(amount, currency);
            return value;
        }
        return (
            <>
                <FormGroup.Input {...{
                    skipLabel: true,
                    id: currency_id,
                    defaultValue: currency,
                    pullRight: true,
                    style: {maxWidth: '121px', marginLeft: '5px'}
                }}/>
                <FormGroup.Input {...{
                    skipLabel: true,
                    id: amount_id,
                    defaultValue: amount,
                    pullRight: true,
                    style: {maxWidth: '200px'}
                }}/>
            </>
        );
    }

    private getShippingAddress(input: boolean): ReactElement {
        return (
            <Table.TBody {...{
                data: [
                    [this.dictionary.get['name'], this.getInput(input, 'shipping_name', Util.copyCell(this.state?.item.shipping_name || ''))],
                    [this.dictionary.get['contact_name'], this.getInput(input, 'shipping_contact_name', Util.copyCell(this.state?.item.shipping_contact_name || ''))],
                    [this.dictionary.get['email'], this.getInput(input, 'shipping_email', Util.copyCell(this.state?.item.shipping_email || ''))],
                    [this.dictionary.get['phone'], this.getInput(input, 'shipping_phone', Util.copyCell(this.state?.item.shipping_phone || ''))],
                    [this.dictionary.get['country'], this.getInput(input, 'shipping_country', Util.copyCell(this.state?.item.shipping_country || ''))],
                    [this.dictionary.get['state'], this.getInput(input, 'shipping_state', Util.copyCell(this.state?.item.shipping_state || ''))],
                    [this.dictionary.get['city'], this.getInput(input, 'shipping_city', Util.copyCell(this.state?.item.shipping_city || ''))],
                    [this.dictionary.get['postcode'], this.getInput(input, 'shipping_postcode', Util.copyCell(this.state?.item.shipping_postcode || ''))],
                    [this.dictionary.get['address1'], this.getInput(input, 'shipping_address1', Util.copyCell(this.state?.item.shipping_address1 || ''))],
                    [this.dictionary.get['address2'], this.getInput(input, 'shipping_address2', Util.copyCell(this.state?.item.shipping_address2 || ''))]
                ]
            }}/>
        );
    }

    private getShippingInfo(input: boolean): ReactElement {
        return (
            <Table.TBody {...{
                data: [
                    [this.dictionary.get['fulfiller'], this.state?.item.fulfillment_service_name || '-'],
                    [this.dictionary.get['queue_id'], Util.copyCell(this.state?.item.queue_id || '-')],
                    [this.dictionary.get['fulfillment_id'], Util.copyCell(this.state?.item.fulfillment_id || '-')],
                    [this.dictionary.get['fulfillment_invoice_id'], Util.copyCell(this.state?.item.fulfillment_invoice_id || '-')],
                    [this.dictionary.get['cod'], this.getPrice(input, 'cod_amount', this.state?.item.cod_amount, 'cod_currency', this.state?.item.cod_currency || null)],
                    [this.dictionary.get['tracking_no'], Util.copyCell(this.state?.item.tracking_no || '-')],
                    [this.dictionary.get['shipment_no'], Util.copyCell(this.state?.item.shipment_no || '-')],
                    [this.dictionary.get['shipment_source_no'], Util.copyCell(this.state?.item.shipment_source_no || '-')],
                    [this.dictionary.get['fulfillment_customer_id'], Util.copyCell(this.state?.item.fulfillment_customer_id || '-')],
                    [this.dictionary.get['shipping_agent'], this.getInput(input, 'shipping_agent', Util.copyCell(this.state?.item.shipping_agent || ''))],
                    [this.dictionary.get['shipping_method'], this.getInput(input, 'shipping_method', Util.copyCell(this.state?.item.shipping_method || ''))],
                    [this.dictionary.get['shipping_location_id'], this.getInput(input, 'shipping_location_id', Util.copyCell(this.state?.item.shipping_location_id || ''))]
                ]
            }}/>
        );
    }

    private getDetails(input: boolean): ReactElement {

        const parentLink = this.state?.item.parent_id ? '/order/details/' + this.state?.item.parent_id : '';
        return (
            <Table.TBody {...{
                data: [
                    [this.dictionary.get['origin'], this.state?.item.service_name || ''],
                    [this.dictionary.get['id'], Util.copyCell(this.state?.item.id || '')],
                    [this.dictionary.get['parent_id'], Util.copyCell(this.state?.item.parent_id || '-')],
                    [this.dictionary.get['parent'], this.state?.item.parent_id ? Util.link(this.state?.item.parent_name, parentLink) : '{{skip-row}}'],
                    [this.dictionary.get['reference_id'], Util.copyCell(this.state?.item.reference_id || '-')],
                    [this.dictionary.get['reference_no'], Util.copyCell(this.state?.item.reference_no || '-')],
                    [this.dictionary.get['reference_name'], Util.copyCell(this.state?.item.reference_name || '-')],
                    [this.dictionary.get['status'], this.getStatus(input, this.state?.item.status)],
                    [this.dictionary.get['type'], this.getType(input, this.state?.item.type)],
                    [this.dictionary.get['scheduled_to'], DateTime.create({
                        value: this.state?.item.scheduled_to,
                        empty: this.dictionary.get['instant-processing'],
                        inline: true
                    })],
                    [this.dictionary.get['total'], this.getPrice(input, 'total_amount', this.state?.item.total_amount, 'total_currency', this.state?.item.total_currency || null)],
                ]
            }}/>
        );
    }

    private editDetails(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#edit-details') as HTMLElement);
    }

    private editShippingInfo(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#edit-shipping-info') as HTMLElement);
    }

    private editShippingAddress(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#edit-shipping-address') as HTMLElement);
    }

    private openOperations(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#open-operations') as HTMLElement);
    }


}
